import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import ReactTooltip from 'react-tooltip';

import ReactHintFactory from 'react-hint';

const ReactHint = ReactHintFactory(React);

const Tooltip = (props) => {
	const { tooltipAt = 'top', tooltipText, tooltipContent, fieldKey } = props;

	if (_.isString(tooltipText) !== true) {

		return null;
	}

	return (
		<span>
			<a data-tip data-for={ `${fieldKey}-tooltip` }>{ `(${tooltipText})` }</a>

			<ReactTooltip id={ `${fieldKey}-tooltip` } className="hfm-tooltip" effect="solid" place={ tooltipAt }>
				<div className="padding-1">
					{ tooltipContent }
				</div>
			</ReactTooltip>
		</span>
	);
};

const ErrorTooltip = (props) => {
	const { fieldKey, errorMessage, tooltipAt = 'top' } = props;

	if (_.isEmpty(errorMessage)) {

		return null;
	}

	const style = {
		width: '20rem'
	};

	return (
		<span>
			<a data-tip data-for={ `${fieldKey}-err-msg` }>
				{
					<span className="far fa-exclamation-triangle" style={{color:'#cc4b37'}}></span>
				}
			</a>

			<ReactTooltip id={ `${fieldKey}-err-msg` } type="error" effect="solid" place={ tooltipAt }>
				<div style={ style }>
					{ errorMessage }
				</div>
			</ReactTooltip>
		</span>
	);
};

const Required = ({ required }) => {
	if (required !== true) {

		return null;
	}

	return (
		<span className="fas fa-asterisk required"></span>
	);
};

const Label = (props) => {
	const {
		label,
		required,
		tooltipContent,
		tooltipText,
		tooltipAt = 'top',
		fieldKey
	} = props;

	if (_.isEmpty(label)) {

		return null;
	}

	return (
		<label htmlFor={ fieldKey }>
			<ErrorTooltip
				fieldKey={ fieldKey }
			/> { `${label} ` }

			<Tooltip
				tooltipContent={ tooltipContent }
				tooltipText={ tooltipText }
				fieldKey={ fieldKey }
			/>

			<Required
				required={ required }
			/>
		</label>
	);
};

export default observer((props) => {
    const { inputComp, fieldClass, floatLabel = false } = props;
    const childProps = _.omit(props, 'inputComp');

    const fieldClassList = ['hfm-field', fieldClass, 'grid-x'];
    const className = fieldClassList.join(' ');
    const labelCellClass = floatLabel ? 'auto small-order-2' : 'small-12';
    const inputCellClass = floatLabel ? 'small-1 small-order-1' : 'small-12';

    return (
        <div className={ className }>
            <ReactHint events={ { hover: false } } persist />

            <div className={ `cell ${labelCellClass}` }>
                <Label { ...childProps } />
            </div>

            <div className={ `cell ${inputCellClass}` }>
                {inputComp}
            </div>
        </div>
    );
});
